import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { AbbIconComponent } from '@components/abb-icon/abb-icon.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'abb-toast',
  standalone: true,
  imports: [CommonModule, AbbIconComponent],
  template: `
    <abb-icon
      [name]="
        data.type === 'success'
          ? 'abb/check-mark-circle-1'
          : data.type === 'warning'
          ? 'abb/warning-triangle'
          : 'abb/warning-circle-1'
      "
    ></abb-icon>
    @if(data.htmlMessage ?? false){
    <span [innerHTML]="data.message | async"></span>
    } @else {
    <span>{{ data.message | async }}</span>
    } @if (data.queueSize$ | async) {
    <div
      class="absolute right-1 top-1 bg-abb-gray_03/75 !text-abb-white w-5 h-5 text-xs flex items-center justify-center leading-none rounded-full"
    >
      +{{ data.queueSize$ | async }}
    </div>
    }
  `,
  styles: ``,
  host: {
    class: 'flex items-center justify-content-between gap-2',
  },
})
export class AbbToastComponent {
  snackBarRef = inject(MatSnackBarRef);

  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      message: Observable<string>;
      htmlMessage?: boolean;
      type: 'error' | 'warning' | 'success';
      queueSize$: Observable<number>;
    }
  ) {}
}
